// extracted by mini-css-extract-plugin
export var option = "_3s-1";
export var optionActive = "_3s-2";
export var pill = "_3s-0";